interface CampPaymentNudgeScope {
  userId: string;
  sessionId: string;
}

const CAMP_NUDGE_DISMISSED_KEY_PREFIX = 'bhcs.campPaymentNudge.blockingDismissed';

function getCampNudgeDismissedStorageKey(scope: CampPaymentNudgeScope): string {
  return `${CAMP_NUDGE_DISMISSED_KEY_PREFIX}:${scope.userId}:${scope.sessionId}`;
}

export function getCampPaymentNudgeScope(
  userId: string | null | undefined,
  sessionId: string | null | undefined
): CampPaymentNudgeScope | null {
  if (!userId || !sessionId) return null;
  return { userId, sessionId };
}

export function hasDismissedCampBlockingNudge(scope: CampPaymentNudgeScope | null): boolean {
  if (!scope || typeof window === 'undefined') return false;

  try {
    return window.sessionStorage.getItem(getCampNudgeDismissedStorageKey(scope)) === '1';
  } catch {
    return false;
  }
}

export function markCampBlockingNudgeDismissed(scope: CampPaymentNudgeScope | null): void {
  if (!scope || typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(getCampNudgeDismissedStorageKey(scope), '1');
  } catch {
    // Ignore storage write errors (e.g. privacy mode restrictions)
  }
}
